
itsoftApp.createModule("slidersLibrary", function () {
    const module = this;

    const Slider = function (el, sliderSettings, cb, currentSlide) {
        this.el = el;
        this.sliderSettings = sliderSettings;
        this.currentSlide = currentSlide;
        this.sliderContainer = el.querySelector(".swiper-container");
        this.navigation = el.querySelector(".swiper-navigation");
        this.pagination = el.querySelector(".swiper-pagination");
        this.scrollbar = el.querySelector(".swiper-scrollbar");
        this.dataDevice = el.getAttribute("data-destroy-device");
        this.destroyDirection = el.getAttribute("data-destroy-direction");
        this.withoutNavigation = el.hasAttribute("data-without-navigation");
        this.withoutPagination = el.hasAttribute("data-without-pagination");
        this.isInitialized = false;
        this.initializedSlider = null;

        this.init();
    };

    Slider.prototype.init = function () {
        const SLIDER = this;
        const outerNavName = SLIDER.sliderContainer.getAttribute("data-slider-name") || SLIDER.sliderSettings.sliderName || "";
        SLIDER.outerNavigation = document.querySelector("[data-slider-nav='" + outerNavName + "']");

        Slider.prototype.onWindowResize = function () {
            const SLIDER = this;

            if (SLIDER.destroyDirection === "from" && SLIDER.dataDevice && itsoftApp.utils.getViewportSize() >= +SLIDER.dataDevice) {
                if (SLIDER.isInitialized === true) {
                    SLIDER.destroySlider();
                }
            } else if (SLIDER.destroyDirection === "to" && SLIDER.dataDevice && itsoftApp.utils.getViewportSize() <= +SLIDER.dataDevice) {
                if (SLIDER.isInitialized === true) {
                    SLIDER.destroySlider();
                }
            } else {
                if (SLIDER.isInitialized === false) {
                    SLIDER.initSlider();
                    DEBUG && console.log("init", ' ' + outerNavName)
                }
            }
        };

        Slider.prototype.createSlider = function () {
            if (!SLIDER.sliderSettings) {
                return;
            }

            if (!SLIDER.withoutNavigation && (SLIDER.navigation || SLIDER.outerNavigation)) {
                const prevBtn = (SLIDER.navigation && SLIDER.navigation.querySelector(".js-prev-btn")) || (SLIDER.outerNavigation && SLIDER.outerNavigation.querySelector(".js-prev-btn"));
                const nextBtn = (SLIDER.navigation && SLIDER.navigation.querySelector(".js-next-btn")) || (SLIDER.outerNavigation && SLIDER.outerNavigation.querySelector(".js-next-btn"));

                SLIDER.sliderSettings.navigation = {};
                SLIDER.sliderSettings.navigation.prevEl = prevBtn;
                SLIDER.sliderSettings.navigation.nextEl = nextBtn;
            }

            if (!SLIDER.withoutPagination && SLIDER.pagination) {
                if (!SLIDER.sliderSettings.pagination) {
                    SLIDER.sliderSettings.pagination = {};
                }
                SLIDER.sliderSettings.pagination.el = SLIDER.pagination;

                if (SLIDER.pagination.classList.contains("js-pagination-dots")) {
                    SLIDER.sliderSettings.pagination.type = "bullets";
                    SLIDER.sliderSettings.pagination.clickable = true;
                } else if (SLIDER.pagination.classList.contains("js-pagination-progress")) {
                    SLIDER.sliderSettings.pagination.type = "progressbar";
                    // SLIDER.sliderSettings.pagination.clickable = true;
                } else {
                    SLIDER.sliderSettings.pagination.type = "fraction";
                    SLIDER.sliderSettings.pagination.renderFraction = function (currentClass, totalClass) {
                        return "<span class='" + currentClass + "'></span>" +
                              "/" +
                              "<span class='"+ totalClass + "'></span>";
                    };
                }
            }

            if (SLIDER.scrollbar) {
                const scrollbar = SLIDER.el.querySelector(".swiper-scrollbar");
                SLIDER.sliderSettings.scrollbar = {};
                SLIDER.sliderSettings.scrollbar.el = scrollbar;
                SLIDER.sliderSettings.scrollbar.draggable = true;
            }

            if (SLIDER.dataDevice) {
                SLIDER.onWindowResize.call(SLIDER);
                itsoftApp.modules.windowResize.addEvent(SLIDER.onWindowResize.bind(SLIDER)); // TODO: проверить this
            } else {
                SLIDER.initSlider();
            }
        };

        new itsoftApp.modules.startLoad.callback(this.createSlider, itsoftApp.libraries.slider);
    };

    Slider.prototype.destroySlider = function () {
        this.initializedSlider.destroy(false, true);
        this.initializedSlider = undefined;
        this.isInitialized = false;
    };

    Slider.prototype.initSlider = function () {
        this.initializedSlider = new Swiper(this.sliderContainer, this.sliderSettings);

        if (this.initializedSlider) {
            if (this.currentSlide) {
                this.initializedSlider.slideTo(+this.currentSlide);
            }

            this.isInitialized = true;
        }
    };

    module.callback = Slider;
});